import React from 'react';
import Link from '../../Utils/Link';
import { Theme } from '@mui/material';
import { NavItemProps } from './NavItem';
import { useLocation } from 'react-router-dom';

const HamburgerMenuItem = ({ item, onClick }: NavItemProps) => {
    const loc = useLocation();
    const isAllSame = item.activeUrls.some((u) => loc.pathname === u);

    const style = (t: Theme) => ({
        color: isAllSame ? t.palette.primary.main : 'white',
        display: 'block',
        padding: 1,
        fontSize: 18,
        fontWeight: 'bold',
        textDecoration: 'none'
    });

    return (
        <Link sx={style} onClick={onClick} to={item.href}>
            {item.label}
        </Link>
    );
};

export default HamburgerMenuItem;
